import { v4 as uuid } from "uuid";

import classes from "../../scss/IosDevelopment.module.scss";
import Hero from "../../components/Service/Hero";
import HeroTitle from "../../components/Service/HeroTitle";
import HeroText from "../../components/Service/HeroText";
import ContentContainer from "../../components/Service/ContentContainer";
import Wrapper from "../../components/Service/Wrapper";
import RequestDemo from "../../components/Button/RequestDemo";
import Section from "../../components/Service/Section";
import SectionTitle from "../../components/Service/SectionTitle";
import { data } from "../../data/iosDevelopment";
import Description from "../../components/Service/Description";
import SectionList from "../../components/Service/SectionList";
import Slide from "../../components/Service/Slide";
import SectionText from "../../components/Service/SectionText";

export default function IosDevelopment() {
  return (
    <Wrapper className={classes.iosDevelopment}>
      <Hero className={classes.hero}>
        <ContentContainer>
          <div className={classes.hero__body}>
            <Slide className={classes.hero__slide}>
              <HeroTitle
                title={data.hero.title}
                className={classes.hero__title}
              />
              <HeroText text={data.hero.text} className={classes.hero__text} />

              <RequestDemo className={classes.hero__button} />
            </Slide>
            <Slide className={classes.hero__slide}>
              <picture>
                <source
                  srcSet={data.hero.images.full}
                  media="(min-height: 1024px)"
                  width="366px"
                  height="774px"
                />
                <img
                  src={data.hero.images.regular}
                  alt="Phone"
                  width="366px"
                  height="656px"
                />
              </picture>
            </Slide>
          </div>
        </ContentContainer>
      </Hero>
      <Description
        title={data.description.title}
        text={data.description.text}
      />

      <Section className={classes.languages}>
        <ContentContainer>
          <SectionTitle
            title={data.iosLanguages.title}
            className={classes.languages__title}
          />
          <div className={classes.languages__body}>
            {data.iosLanguages.content.map((item) => {
              return item.paragraph ? (
                <SectionText
                  key={uuid()}
                  text={item.paragraph}
                  className={classes.languages__text}
                />
              ) : item.list ? (
                <SectionList
                  key={uuid()}
                  list={item.list}
                  className={`${classes.languages__list} ${classes.list}`}
                />
              ) : (
                ""
              );
            })}
          </div>
        </ContentContainer>
      </Section>

      <Section className={classes.development}>
        <ContentContainer>
          <SectionTitle
            title={data.iosProcess.title}
            className={classes.developments__title}
          />
          <div className={classes.development__body}>
            <div className={classes.development__text}>
              {data.iosProcess.content.map((item) => {
                return item.paragraph ? (
                  <SectionText
                    key={uuid()}
                    text={item.paragraph}
                    className={classes.development__text}
                  />
                ) : item.list ? (
                  <SectionList
                    key={uuid()}
                    list={item.list}
                    className={`${classes.development__list} ${classes.list}`}
                  />
                ) : (
                  ""
                );
              })}
            </div>
            <div className={classes.development__image}>
              <img
                width="332"
                height="525"
                src={data.iosProcess.image}
                alt={data.iosProcess.title}
              />
            </div>
          </div>
        </ContentContainer>
      </Section>

      <Section className={classes.choose}>
        <ContentContainer>
          <div className={classes.choose__body}>
            <SectionTitle
              title={data.whyChoose.title}
              className={classes.choose__title}
            />
            <div className={classes.choose__text}>
              <SectionText text={data.whyChoose.description} />
            </div>
          </div>
        </ContentContainer>
      </Section>
    </Wrapper>
  );
}
